/**
 * Translated Home page body.
 *
 * Mirrors the English CMS HTML for page_id "home" (classes, links, images stay
 * identical) so the existing Home.css / PageViewer.css styling applies unchanged.
 * Only human-readable text is translated. Proper nouns and published book titles
 * stay in English.
 */

const frenchHome = (d) => `
<center>
  <h1>Bienvenue chez Cranford Publications</h1>
  <p class="intro-text">
    Spécialistes de la musique celtique pour violon du Cap-Breton, d'Irlande et d'Écosse
  </p>
  <a href="https://www.cranfordpub.ca/product/642">
    <img src="/api/assets/2399/download" alt="Recueils de musique" style="max-width:60%;" />
  </a>
  <hr class="divider" />

  <h2>🎻 Plus de 45 ans de publications musicales</h2>
  <p>Fournisseur de beaux airs de violon depuis 1979.</p>
</center>

<p>
  Depuis 1979, Cranford Publications préserve et fait rayonner les traditions du violon celtique.
  Ce qui a commencé par la réédition de <em>The Skye Collection</em> est devenu un catalogue complet
  de recueils de musique traditionnelle, d'enregistrements et de matériel pédagogique. Pour en savoir
  <a href="/about">plus sur Paul Cranford</a> et ses publications, visitez la page
  <a href="/about">À propos</a>.
</p>

<section class="contact-section">
  <h2>📚 Ce que nous offrons</h2>
  <div class="info-box">
    <div class="business-info-grid" style="margin-bottom:1rem;">
      <div class="info-item">
        <div class="info-label">Fondée en</div>
        <div class="info-value">1979</div>
        <div class="info-subtext">Plus de 40 ans</div>
      </div>
      <div class="info-item">
        <div class="info-label">Collections</div>
        <div class="info-value">12+</div>
        <div class="info-subtext">Livres publiés</div>
      </div>
      <div class="info-item">
        <div class="info-label">Airs</div>
        <div class="info-value">Des milliers</div>
        <div class="info-subtext">Documentés et préservés</div>
      </div>
      <div class="info-item">
        <div class="info-label">${d.locationLabel}</div>
        <div class="info-value">Cap-Breton</div>
        <div class="info-subtext">Nouvelle-Écosse, Canada</div>
      </div>
    </div>

    <ul class="shipping-list" style="margin-top:1.25rem;">
      <li>🎻 <strong><a href="/product/642">The Cape Breton Musical Heritage Series</a></strong> —
        la célèbre collection Cape Breton Musical Heritage (9 volumes). Depuis plus de 40 ans, Paul
        assemble cette série de recueils qui réunissent au total plus de 2 500 mélodies en 10 volumes.
        Ce projet toujours en cours constitue l'une des documentations les plus complètes jamais
        réalisées sur la musique de violon du Cap-Breton.</li>
      <li>🎼 <strong>Recueils de musique</strong> — airs traditionnels avec notation et chiffrage
        d'accords du Cap-Breton, d'Irlande et d'Écosse</li>
      <li>💿 <strong>CD et enregistrements</strong> — interprétations authentiques de musique celtique
        par des violoneux de renom</li>
      <li>📖 <strong>Matériel pédagogique</strong> — <a href="/articles">articles</a> et ressources
        (notation et commentaires) pour apprendre la musique traditionnelle, y compris des extraits
        d'airs gratuits en ligne</li>
      <li>📱 <strong><a href="/tunes">Airs</a></strong> — des milliers de liens vers des airs,
        d'extraits sonores et de partitions accessibles en ligne</li>
    </ul>
  </div>
</section>

<hr class="divider" />

<section class="contact-section">
  <p class="contact-note-center">
    <strong><a href="/shop">Explorez nos ressources</a></strong> et découvrez le riche patrimoine des
    traditions musicales du Cap-Breton, d'Irlande et d'Écosse. Des compilations historiques aux
    compositions contemporaines, nous proposons une sélection de livres et d'enregistrements, mais
    aussi des <a href="/articles">articles et ressources gratuits</a> pour encourager la continuation
    de cette tradition.
  </p>
</section>
`;

const germanHome = `
<center>
  <h1>Willkommen bei Cranford Publications</h1>
  <p class="intro-text">
    Spezialisiert auf keltische Fiddle-Musik aus Cape Breton, Irland und Schottland
  </p>
  <a href="https://www.cranfordpub.ca/product/642">
    <img src="/api/assets/2399/download" alt="Notenbücher" style="max-width:60%;" />
  </a>
  <hr class="divider" />

  <h2>🎻 45+ Jahre Musikpublikationen</h2>
  <p>Lieferant feiner Fiddle-Melodien seit 1979.</p>
</center>

<p>
  Seit 1979 bewahrt und fördert Cranford Publications die Traditionen der keltischen Fiddle-Musik.
  Was mit einer Neuauflage von <em>The Skye Collection</em> begann, ist zu einem umfassenden Katalog
  aus traditionellen Notenbüchern, Aufnahmen und Lehrmaterialien gewachsen. Mehr
  <a href="/about">über Paul Cranford</a> und seine Publikationen finden Sie auf der Seite
  <a href="/about">Über uns</a>.
</p>

<section class="contact-section">
  <h2>📚 Unser Angebot</h2>
  <div class="info-box">
    <div class="business-info-grid" style="margin-bottom:1rem;">
      <div class="info-item">
        <div class="info-label">Gegründet</div>
        <div class="info-value">1979</div>
        <div class="info-subtext">Über 40 Jahre</div>
      </div>
      <div class="info-item">
        <div class="info-label">Sammlungen</div>
        <div class="info-value">12+</div>
        <div class="info-subtext">Veröffentlichte Bücher</div>
      </div>
      <div class="info-item">
        <div class="info-label">Melodien</div>
        <div class="info-value">Tausende</div>
        <div class="info-subtext">Dokumentiert und bewahrt</div>
      </div>
      <div class="info-item">
        <div class="info-label">Standort</div>
        <div class="info-value">Cape Breton</div>
        <div class="info-subtext">Nova Scotia, Kanada</div>
      </div>
    </div>

    <ul class="shipping-list" style="margin-top:1.25rem;">
      <li>🎻 <strong><a href="/product/642">The Cape Breton Musical Heritage Series</a></strong> —
        die renommierte Cape Breton Musical Heritage Collection (9 Bände). In den letzten mehr als
        40 Jahren hat Paul diese Buchreihe zusammengestellt, die insgesamt über 2.500 Melodien in
        10 Bänden enthält. Dieses laufende Projekt gehört zu den umfassendsten Dokumentationen der
        Fiddle-Musik von Cape Breton.</li>
      <li>🎼 <strong>Notenbücher</strong> — traditionelle Melodien mit Notation und Akkordsymbolen
        aus Cape Breton, Irland und Schottland</li>
      <li>💿 <strong>CDs und Aufnahmen</strong> — authentische keltische Musik, gespielt von
        renommierten Fiddlern</li>
      <li>📖 <strong>Lehrmaterialien</strong> — <a href="/articles">Artikel</a> und Ressourcen
        (Notation und Erläuterungen) zum Erlernen traditioneller Musik, einschließlich kostenloser
        Melodiebeispiele online</li>
      <li>📱 <strong><a href="/tunes">Musik</a></strong> — Tausende Melodie-Links, Hörbeispiele und
        Notationen online verfügbar</li>
    </ul>
  </div>
</section>

<hr class="divider" />

<section class="contact-section">
  <p class="contact-note-center">
    <strong><a href="/shop">Entdecken Sie unsere Ressourcen</a></strong> und das reiche Erbe der
    Musiktraditionen von Cape Breton, Irland und Schottland. Von historischen Sammlungen bis zu
    zeitgenössischen Kompositionen bieten wir eine Auswahl an Büchern und Aufnahmen, aber auch
    <a href="/articles">kostenlose Artikel und Ressourcen</a>, um diese Tradition weiterzutragen.
  </p>
</section>
`;

export const HOME_PAGE_TRANSLATIONS = {
  'fr-CA': {
    title: 'Accueil',
    description:
      'Bienvenue chez Cranford Publications — musique celtique pour violon du Cap-Breton, d\'Irlande et d\'Écosse.',
    html: frenchHome({ locationLabel: 'Emplacement' }),
  },
  'fr-FR': {
    title: 'Accueil',
    description:
      'Bienvenue chez Cranford Publications — musique celtique pour violon du Cap-Breton, d\'Irlande et d\'Écosse.',
    html: frenchHome({ locationLabel: 'Lieu' }),
  },
  de: {
    title: 'Startseite',
    description:
      'Willkommen bei Cranford Publications — keltische Fiddle-Musik aus Cape Breton, Irland und Schottland.',
    html: germanHome,
  },
};
